import { Button, Form, Input, Modal } from "antd";
import React, { useState } from "react";
import { getLocalStorageItem } from "../../../Utils";
import { AddFund2Viagateway } from "../../../ApiServices/Apifun";

const AddFund2 = () => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleFinish = (val) => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("amount", val.amount);
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));

    AddFund2Viagateway(formdata)
      .then((res) => {
        if (res.status) {
          window.open(res.request_data?.payment_data?.checkoutUrl, "_blank");
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-1 gap-4 place-items-start">
      <div className="prepaid animate-slide-in w-full  bg-white shadow-normal  rounded-3xl p-5">
        <p className="font-bold text-[15px] mb-2"> Add Fund </p>
        <Form
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinishFailed={(err) => console.log(err)}
          onFinish={(val) => handleFinish(val)}
        >
          <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-8 place-items-start">
            <Form.Item
              name={`amount`}
              label={"Amount"}
              className="w-full"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Amount!",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Enter Amount"
                name="amount"
                className="outline-none text-xs border  w-full border-gray-200 focus:border-primary  h-9 px-2 "
              />
            </Form.Item>
          </div>
          <div className="flex justify-end items-center ">
            <Form.Item>
              <Button
                loading={btnLoading}
                className="w-full bg-primary border-none mt-4"
                style={{ color: "white" }}
                htmlType="submit"
              >
                Send
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddFund2;
